import {Injectable} from "@angular/core";
import {HttpClient, HttpParams} from "@angular/common/http";
import {Observable} from "rxjs";
import {environment} from "@environments/environment";
import {Result} from "@domain/common/http/result";
import {MessageNotif} from "@domain/notification/message-notif";
import {TypeMessageNotif} from "@domain/notification/type-message-notif";
import {TypePushNotification} from "@domain/notification/type-push-notification";

@Injectable({providedIn: 'root'})
export class NotificationMessagesService {

    constructor(private http: HttpClient) {}

    /**
     * Chargement d'un message par id
     *
     * @param idMessage id du message
     * @return result contenant le message
     */
    getMessageById(idMessage: number): Observable<Result<{message: MessageNotif}>> {
        const params = new HttpParams().set('id_message', String(idMessage));
        return this.http.post<Result<{message: MessageNotif}>>(
            environment.baseUrl + '/controller/MessageNotif/getById',
            null,
            {params}
        );
    }

    /**
     * Enregistrement d'un message (création/modification)
     *
     * @param message message à enregistrer
     * @return result contenant l'id créé
     */
    saveMessage(message: MessageNotif): Observable<Result<{id_message?: number}>> {
        const body = new HttpParams()
            .set('idMessage', String(message?.idMessage ?? 0))
            .set('titre', message?.titre ?? '')
            .set('type', message?.type ?? TypeMessageNotif.EMAIL)
            .set('sujet', message?.sujet ?? '')
            .set('corps', message?.corps ?? '')
            .set('globalise', String(!!message?.globalise))
            .set('typePushNotification', message?.typePushNotification ?? TypePushNotification.NON_DEFINI);

        return this.http.post<Result<{id_message?: number}>>(
            environment.baseUrl + '/controller/Notification/saveMessage',
            body.toString(),
            {headers: {'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'}}
        );
    }

    /**
     * Suppression d'un message
     *
     * @param idMessage id de l'E-mail à supprimer
     * @return result de la suppression
     */
    deleteMessage(idMessage: number): Observable<Result> {
        const params = new HttpParams().set('id_message', String(idMessage));
        return this.http.post<Result>(
            environment.baseUrl + '/controller/Notification/deleteMessage',
            null,
            {params}
        );
    }
}